import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Colors } from '@oy/uicore';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useEnv } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';
import { storage } from 'src/utilities/Storage';

export const useUserMenuImpl = () => {
  const { isProdEnv } = useEnv();
  const [isHover, setIsHover] = useState(false);
  const user = useSelector((state: RootState) => state.auth.user);
  const [showOnboardUserMenu, setShowOnboardUserMenu] = useState(() => {
    if (!user?.username) return false;
    return !storage.get(
      'onboard:new_user_menu:' + user.username,
      false,
    ) as boolean;
  });

  const getColor = () => {
    if (!isProdEnv) return Colors.BLACK100;
    if (!isHover) return Colors.WHITE;
    return Colors.BLUE100;
  };

  const onCloseOnboardUserMenu = () => {
    if (!user?.username) return;
    setShowOnboardUserMenu(false);
    storage.set('onboard:new_user_menu:' + user.username, true);
  };

  const onClickUserMenu = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_settings_menu);
  };

  return {
    getColor,
    user,
    setIsHover,
    isProdEnv,
    showOnboardUserMenu,
    onCloseOnboardUserMenu,
    onClickUserMenu,
  };
};
